import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs/Observable';
import { Camera } from '../models/camera.model';
import { User } from '../models/user.model';

@Injectable()
export class CameraService extends BaseService {

  protected makeModel(data: any): Camera {
    return new Camera(data);
  }

  index(): Observable<Camera[]> {
    return this.http.get(this.url('cameras'), this.getRequestOptions())
      .map(this.extractData)
      .map(this.mapResourceData)
      .catch(this.handleError);
  }

  public store(camera: Camera) {
    return this.http.post(this.url('cameras'), camera, this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public destroy(camera: Camera) {
    return this.http.delete(this.url(`cameras/${camera._id}`), this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public update(camera: Camera) {
    return this.http.put(this.url(`cameras/${camera._id}`), camera, this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public show(_id) {
    return this.http.get(this.url(`cameras/${_id}`), this.getRequestOptions())
      .map(this.extractData)
      .map(this.mapResourceData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/services/camera.service.ts